<div class="mb-5">
    <a routerLink="/sistemerp/proiecte/lista" class="btn btn-primary font-weight-bold text-uppercase px-9 py-4">
        <i class="icofont-arrow-left"></i> Inapoi la proiecte
    </a>
</div>

<div class="card card-custom gutter-b" xmlns="http://www.w3.org/1999/html">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Editare proiect - {{project.projectNumber}}</h3>
        </div>
    </div>
    <div class="card-body">
        <!--begin: Wizard -->
        <div
            #wizard
            class="wizard wizard-4"
            data-wizard-state="step-first"
            id="kt_wizard_v4"
        >
            <!--begin: Form Wizard Nav -->
            <div class="wizard-nav">
                <div class="wizard-steps">
                    <a
                            class="wizard-step"
                            data-wizard-state="current"
                            data-wizard-type="step"
                            href="javascript:;"
                    >
                        <div class="wizard-wrapper">
                            <div class="wizard-number">1</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Date de identificare</div>
                                <!--                                <div class="wizard-desc">Client, responsabili, beneficiar</div>-->
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">2</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Detalii Job</div>
                                <!--                                <div class="wizard-desc">Setup Your Address</div>-->
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">3</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Cerinte Job</div>
                                <!--                                <div class="wizard-desc">Add Payment Options</div>-->
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">4</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Recrutare</div>
                                <!--                                <div class="wizard-desc">Review and Submit</div>-->
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">5</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Buget</div>
                                <!--                                <div class="wizard-desc">Review and Submit</div>-->
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <!--end: Form Wizard Nav -->

            <div class="card card-custom card-shadowless rounded-top-0">
                <div class="card-body p-0">
                    <div class="row justify-content-center pt-10">
                        <div class="col-xl-12">
                            <!--begin: Form Wizard Form-->
                            <form #updateProject="ngForm" (ngSubmit)="onSubmit(updateProject)"  class="form mt-0 mt-lg-10">
                                <!--begin: Form Wizard Step 1-->
                                <div
                                        class="pb-5"
                                        data-wizard-state="current"
                                        data-wizard-type="step-content"
                                >
                                    <div class="row mb-10">
                                        <div class="col-md-12">
                                            <h3>
                                                Date identificare interne ABJ
                                            </h3>

                                            <div class="form-group">
                                                <label>Nume proiect</label>
                                                <input type="text" [(ngModel)]="project.name" name="name" class="form-control" required #projectName="ngModel"/>
                                                <div class="error-msg" *ngIf="!projectName.valid && (projectName.touched || updateProject.submitted)">
                                                    Acest camp este obligatoriu!
                                                </div>
                                            </div>

                                            <div *ngIf="dataLoaded" class="form-group">
                                                <label>Client</label>
                                                <ng-select2
                                                        [(ngModel)] = project.clientUserId
                                                        [data]="clientsNameArray"
                                                        [options]="clientsOptions"
                                                        name="clientUserId"
                                                        #clientController="ngModel"
                                                        required
                                                >
                                                </ng-select2>
                                                <div class="error-msg" *ngIf="clientController.invalid && (clientController.touched || updateProject.submitted)">
                                                    Acest camp este obligatoriu!
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Contract</label>
                                                <ng-select2
                                                        [ngModel] = project.contract
                                                        [data]="contractNumbers"
                                                        [options]="multiSelectOp"
                                                        name="contract"
                                                >
                                                </ng-select2>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Factura fiscala</label>
                                                <ng-select2
                                                        [ngModel] = project.fiscalBill
                                                        [data]="demoFiscalBill"
                                                        [options]="multiSelectOp"
                                                        name="fiscalBill"
                                                >
                                                </ng-select2>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <h3>Responsabil ABJ cont alocat - Manager de proiect</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nume</label>
                                                <input
                                                        [(ngModel)] = project.projectManagerName
                                                        class="form-control"
                                                        name="projectManagerName"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Prenume</label>
                                                <input
                                                        [(ngModel)] = project.projectManagerLastName
                                                        class="form-control"
                                                        name="projectManagerLastName"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Branch alocat</label>
                                                <input
                                                        [(ngModel)] = project.projectManagerBranch
                                                        class="form-control"
                                                        name="projectManagerBranch"
                                                        type="text"

                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input
                                                        [(ngModel)] = project.projectManagerEmail
                                                        class="form-control"
                                                        name="projectManagerEmail"
                                                        type="email"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Telefon</label>
                                                <input
                                                        [(ngModel)] = project.projectManagerTelephone
                                                        class="form-control"
                                                        name="projectManagerTelephone"
                                                        type="tel"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel</label>
                                                <select [(ngModel)] = project.projectManagerLevel
                                                        class="form-control"
                                                        name="projectManagerLevel"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="junior">Junior</option>
                                                    <option value="specialist">Specialist</option>
                                                    <option value="senior">Senior</option>
                                                    <option value="executive">Top management</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <h3>Responsabil ABJ cont alocat - Recrutor</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nume</label>
                                                <input
                                                        [(ngModel)]=project.recruiterFirstName
                                                        class="form-control"
                                                        name="recruiterFirstName"
                                                        type="text"

                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Prenume</label>
                                                <input
                                                        [(ngModel)]=project.recruiterLastName
                                                        class="form-control"
                                                        name="recruiterLastName"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Branch alocat</label>
                                                <input
                                                        [(ngModel)]=project.recruiterBranch
                                                        class="form-control"
                                                        name="recruiterBranch"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input
                                                        [(ngModel)]=project.recruiterEmail
                                                        class="form-control"
                                                        name="recruiterEmail"
                                                        type="email"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Telefon</label>
                                                <input
                                                        [(ngModel)]=project.recruiterTelephone
                                                        class="form-control"
                                                        name="recruiterTelephone"
                                                        type="tel"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel</label>
                                                <select [(ngModel)]=project.recruiterLevel
                                                        class="form-control"
                                                        name="recruiterLevel"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="junior">Junior</option>
                                                    <option value="specialist">Specialist</option>
                                                    <option value="senior">Senior</option>
                                                    <option value="executive">Top management</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <h3>Responsabil direct de la client (Managerul)</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nume complet</label>
                                                <input
                                                        [(ngModel)]=project.managerName
                                                        class="form-control"
                                                        name="managerName"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Telefon</label>
                                                <input
                                                        [(ngModel)]=project.managerTelephone
                                                        class="form-control"
                                                        name="managerTelephone"
                                                        type="tel"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input
                                                        [(ngModel)]=project.managerEmail
                                                        class="form-control"
                                                        name="managerEmail"
                                                        type="email"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--end: Form Wizard Step 1-->

                                <!--begin: Form Wizard Step 2-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <h3>Detalii job</h3>
                                    <div class="row mb-10">
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Companie angajatoare</label>
                                                <input
                                                        [(ngModel)]=project.employingCompany
                                                        class="form-control"
                                                        name="employingCompany"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Denumire post</label>
                                                <input
                                                        [(ngModel)]=project.jobName
                                                        class="form-control"
                                                        name="jobName"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Numar de posturi</label>
                                                <input
                                                        [(ngModel)]=project.numberAvailableJobs
                                                        class="form-control"
                                                        name="numberAvailableJobs"
                                                        type="number"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Tara locatie post</label>
                                                <select [(ngModel)]=project.jobCountry
                                                        (change)="changeCountry($event)"
                                                        class="form-control"
                                                        id="jobCountry" name="jobCountry" #jobCountry="ngModel" placeholder="Country">
                                                    <option value="0">--Alege tara--</option>
                                                    <option *ngFor="let country of countries">{{country.name}}</option>
                                                </select>
<!--                                                <div class="error-msg" *ngIf="!jobCountry.valid && (jobCountry.touched || updateProject.submitted)">-->
<!--                                                    Acest camp este obligatoriu!-->
<!--                                                </div>-->
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Judet locatie post</label>
                                                <ng-select2
                                                        [ngModel]= project.jobCities
                                                        [data]="cities"
                                                        [options]="multiSelectOp"
                                                        name="jobCities"
                                                        #jobCities="ngModel"
                                                >
                                                </ng-select2>
<!--                                                <div class="error-msg" *ngIf="!jobCities.valid && (jobCities.touched || updateProject.submitted)">-->
<!--                                                    Acest camp este obligatoriu!-->
<!--                                                </div>-->
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel post</label>
                                                <select [(ngModel)]=project.levelJob
                                                        class="form-control"
                                                        name="levelJob"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="junior">Junior</option>
                                                    <option value="specialist">Specialist</option>
                                                    <option value="senior">Senior</option>
                                                    <option value="executive">Top management</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Tip post</label>
                                                <select [(ngModel)]=project.jobType
                                                        class="form-control"
                                                        name="jobType"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="voluntar">Voluntar</option>
                                                    <option value="internship">Internship</option>
                                                    <option value="part-time">Part-time</option>
                                                    <option value="full-time">Full-time</option>
                                                    <option value="temporar">Proiect / Temporar</option>
                                                    <option value="freelancer(persoana-fizica)">Freelancer (persoana fizica)</option>
                                                    <option value="freelance(persoana-juridica)">Freelancer (persoana juridica)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Tip contract</label>
                                                <select [(ngModel)]=project.contractType
                                                        class="form-control"
                                                        name="contractType"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="perioada determinata">Angajat CIM Perioada Determinata</option>
                                                    <option value="perioada nedeterminata">Angajat CIM Perioada Nedeterminata</option>
                                                    <option value="persoana juridica">Persoana Juridica</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Disponibilitate post</label>
                                                <select [(ngModel)]=project.jobAvailability
                                                        class="form-control"
                                                        name="jobAvailability"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="immediate">Imediata</option>
                                                    <option value="in_30_days">In 30 zile</option>
                                                    <option value="in_90_days">In 90 zile</option>
                                                    <option value="in_6_months">In 6 luni</option>
                                                    <option value="in_9_months">In 9 luni</option>
                                                    <option value="in_12_months">In 12 luni</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h2>Sectiune Management</h2>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nume manager direct</label>
                                                <input
                                                        [(ngModel)]=project.directManagerName
                                                        class="form-control"
                                                        name="directManagerName"
                                                        type="text"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Telefon manager direct</label>
                                                <input
                                                        [(ngModel)]=project.directManagerTelephone
                                                        class="form-control"
                                                        name="directManagerTelephone"
                                                        type="tel"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Email manager direct</label>
                                                <input
                                                        [(ngModel)]=project.directManagerEmail
                                                        class="form-control"
                                                        name="directManagerEmail"
                                                        type="email"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Team manager</label>
                                                <label class="checkbox-container">DA
                                                    <input [(ngModel)]=project.teamManager id="teamManager" name="teamManager"
                                                           type="checkbox" value=true>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Posibilitati de cariera</label>
                                                <ng-select2 [(ngModel)]=project.careerPossibility [data]="selectCareerPossibility"
                                                            [options]="multiSelectOp" [placeholder]="'-- Selecteaza optiune --'"
                                                            id="careerPossibility" name="careerPossibility"></ng-select2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h2>Pachet salarial</h2>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Salariu fix</label>
                                                <div class="input-group mb-2">
                                                    <input [(ngModel)]=project.fixedSalary
                                                           class="form-control mb-0" id="fixedSalary"
                                                           name="fixedSalary" type="number">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">€ / lunar</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Bonus</label>
                                                <select [(ngModel)]=project.bonus
                                                        class="form-control"
                                                        name="bonus"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="confidential">Confidential</option>
                                                    <option value="not_offered">Nu se ofera</option>
                                                    <option value="monthly">Lunar</option>
                                                    <option value="quarterly">Trimestrial</option>
                                                    <option value="annual">Anual</option>
                                                    <option value="another_interval">Alt interval</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Valoare medie bonus</label>
                                                <input
                                                        [(ngModel)]=project.averageBonusValue
                                                        class="form-control"
                                                        name="averageBonusValue"
                                                        type="number"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Alte beneficii</label>
                                                <ng-select2 [(ngModel)]=project.otherBenefit
                                                            [options]="multiSelectOp" [placeholder]="'-- Selecteaza optiune --'"
                                                            id="otherBenefit" name="otherBenefit"></ng-select2>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nevoie relocare</label>
                                                <label class="checkbox-container" for="relocation">DA
                                                    <input [(ngModel)]=project.relocation id="relocation" name="relocation"
                                                           type="checkbox" value=true>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Prima relocare</label>
                                                <label class="checkbox-container" for="premiumRelocation">DA
                                                    <input [(ngModel)]=project.premiumRelocation id="premiumRelocation" name="premiumRelocation"
                                                           type="checkbox" value=true>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Locuinta relocare</label>
                                                <select [(ngModel)]=project.relocationHouse class="form-control"
                                                        name="relocationHouse"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="Locuinta single">Locuinta single</option>
                                                    <option value="Locuinta familie">Locuinta familie</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Instrumente de lucru</label>
                                                <ng-select2 [(ngModel)]=project.workingTools [data]="selectWorkingTools"
                                                            [options]="multiSelectOp" [placeholder]="'-- Selecteaza optiune --'"
                                                            id="workingTools" name="workingTools"></ng-select2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12"><h2>Conditii contractuale agentia ABJ</h2></div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Durata de implementare</label>
                                                <div class="input-group mb-2">
                                                    <input [(ngModel)]=project.implementationDuration
                                                            class="form-control mb-0" id="implementationDuration"
                                                           name="implementationDuration" type="number">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">zile</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Numar de candidati propusi</label>
                                                <input [(ngModel)]=project.numberCandidates
                                                        class="form-control mb-0"
                                                       name="numberCandidates" type="number">
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Perioada de garantie</label>
                                                <div class="input-group mb-2">
                                                    <input [(ngModel)]=project.warrantyPeriod
                                                            class="form-control mb-0"
                                                           name="warrantyPeriod" type="number">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">zile</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Perioada de proba client</label>
                                                <div class="input-group mb-2">
                                                    <input [(ngModel)]=project.probationPeriod
                                                            class="form-control mb-0"
                                                           name="probationPeriod" type="number">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">zile</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h2>Evaluare interna ABJ</h2>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel de dificultate</label>
                                                <input [(ngModel)]=project.levelDifficulty
                                                       class="form-control mb-0"
                                                       max="5" min="1"
                                                       name="levelDifficulty" type="number">
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Numar de credite deblocare CVs acordate</label>
                                                <input [(ngModel)]=project.numberCredits
                                                       class="form-control mb-0"
                                                       name="numberCredits" type="number">
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Buget implementare proiect</label>
                                                <input [(ngModel)]=project.projectImplementationBudget
                                                       class="form-control mb-0"
                                                       name="projectImplementationBudget" type="number">
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Proiecte similare</label>
                                                <input [(ngModel)]=project.similarProjects
                                                       class="form-control mb-0"
                                                       name="similarProjects" type="text">
                                            </div>
                                        </div>
                                        <div class="col-xl-6" *ngIf="crmUsersDataLoaded">
                                            <div class="form-group">
                                                <label>Responsabil implementare proiecte similare</label>
                                                <ng-select2
                                                        [(ngModel)]=selectedRecrut
                                                        [data]="crmUsersNameArray"
                                                        [options]="multiSelectOp"
                                                        name="responsibleIdForSimilarProjects"
                                                >
                                                </ng-select2>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <!--end: Form Wizard Step 2-->

                                <!--begin: Form Wizard Step 3-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <h3>
                                        Profil Job - Cerinte
                                    </h3>
                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label>Scopul postului</label>
                                                <textarea
                                                        [(ngModel)]=project.jobPurpose
                                                        class="form-control"
                                                        name="jobPurpose">
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Valori</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Valorile companiei</label> <a (click)="addCompanyValue()" class="form-control add">+</a>
                                                <ng-template
                                                        [ngForOf]="form.companyValues" let-index="index" let-value ngFor ngModelGroup="companyValues"
                                                        [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume valoare</label>
                                                            <input [(ngModel)]=value.name class="form-control"
                                                                   name="name"
                                                                   type="text"/>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Descriere valoare</label>
                                                            <textarea [(ngModel)]=value.description class="form-control" name="description">
                                                                </textarea>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeCompanyValue( index )" class="remove" title="Remove">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Responsabilitati</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Responsabilitati</label> <a (click)="addResponsibility()" class="form-control add">+</a>
                                                <ng-template
                                                        [ngForOf]="form.responsibility" let-index="index" let-responsability ngFor ngModelGroup="responsibility"
                                                        [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume responsabilitate</label>
                                                            <input [(ngModel)]=responsability.name class="form-control"
                                                                   name="name" type="text" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Descriere responsabilitate</label>
                                                            <textarea [(ngModel)]=responsability.description
                                                                      class="form-control" name="description">
                                                                </textarea>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Importanta responsabilitate</label>
                                                            <input [(ngModel)]=responsability.importance class="form-control"
                                                                   name="importance" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Procent din timp</label>
                                                            <select [(ngModel)]=responsability.timePercentage
                                                                    class="form-control" name="timePercentage">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="10%">10%</option>
                                                                <option value="20%">20%</option>
                                                                <option value="30%">30%</option>
                                                                <option value="40%">40%</option>
                                                                <option value="50%">50%</option>
                                                                <option value="60%">60%</option>
                                                                <option value="70%">70%</option>
                                                                <option value="80%">80%</option>
                                                                <option value="90%">90%</option>
                                                                <option value="100%">100%</option>

                                                            </select>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeResponsibility( index )" class="remove" title="Remove responsability">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Abilitati</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Abilitati cerute</label> <a (click)="addSkill()" class="form-control add">+</a>
                                                <ng-template
                                                        [ngForOf]="form.skillRequired" let-index="index" let-skill ngFor ngModelGroup="skillRequired"
                                                        [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row mt-1 mb-1" ngModelGroup="{{index}}">
                                                        <div class="col-md-3">
                                                            <label>Nume abilitate</label>
                                                            <input [(ngModel)]=skill.abilityName
                                                                    class="form-control"
                                                                   name="abilityName" type="text" />
                                                        </div>
                                                        <div class="col-md-3">
                                                            <label>Descriere abilitate</label>
                                                            <textarea [(ngModel)]=skill.abilityDescription
                                                                      class="form-control" name="abilityDescription">
                                                                </textarea>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <label>Nivel abilitate</label>
                                                            <select [(ngModel)]=skill.abilityLevel
                                                                    class="form-control" name="abilityLevel">
                                                                <option value="">--Alege nivelul de abilitate--</option>
                                                                <option value="Baza">Baza</option>
                                                                <option value="Mediu">Mediu</option>
                                                                <option value="Avansat">Avansat</option>
                                                                <option value="Expert">Expert</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <a (click)="removeSkill( index )" class="remove" title="Remove skill">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Studii</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Studii generale</label>
                                                <select [(ngModel)]=project.generalStudies
                                                        class="form-control"
                                                        name="generalStudies"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="high_school">Liceu / Școală profesionala</option>
                                                    <option value="college">Colegiu / Studii postliceala</option>
                                                    <option value="faculty">Facultate</option>
                                                    <option value="master">Masterat</option>
                                                    <option value="MBA">MBA</option>
                                                    <option value="doctorate">Doctorat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Studii de specialitate</label>
                                                <select [(ngModel)]=project.specializedStudies
                                                        class="form-control"
                                                        name="specializedStudies"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="high_school">Liceu / Școală profesionala</option>
                                                    <option value="college">Colegiu / Studii postliceala</option>
                                                    <option value="faculty">Facultate</option>
                                                    <option value="master">Masterat</option>
                                                    <option value="MBA">MBA</option>
                                                    <option value="doctorate">Doctorat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Alte studii</label>
                                                <textarea [(ngModel)]=project.otherStudies
                                                          class="form-control"
                                                          name="otherStudies" >
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Testari</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Testare tehnica</label> <a (click)="addTechnicalTesting()" class="form-control add">+</a>
                                                <ng-template
                                                             [ngForOf]="form.technicalTesting" let-index="index" let-techincalTest ngFor ngModelGroup="technicalTesting"
                                                             [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="techincalTest{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume testare tehnica</label>
                                                            <select [(ngModel)]=techincalTest.name
                                                                    class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Nivel testare tehnica</label>
                                                            <select [(ngModel)]=techincalTest.level
                                                                    class="form-control" name="level">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Baza</option>
                                                                <option value="Mediu">Mediu</option>
                                                                <option value="Avansat">Avansat</option>
                                                                <option value="Expert">Expert</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeTechnicalTesting( index )" class="remove" title="Remove skill">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Testare psihologica</label> <a (click)="addPsychologicalTesting()" class="form-control add">+</a>
                                                <ng-template
                                                        [ngForOf]="form.psychologicalTesting" let-index="index" let-psychologicalTest ngFor ngModelGroup="psychologicalTesting"
                                                        [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="psychologicalTest{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume testare psihologica</label>
                                                            <select [(ngModel)]=psychologicalTest.name
                                                                    class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Nivel testare psihologica</label>
                                                            <select [(ngModel)]=psychologicalTest.level
                                                                    class="form-control" name="level">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Baza</option>
                                                                <option value="Mediu">Mediu</option>
                                                                <option value="Avansat">Avansat</option>
                                                                <option value="Expert">Expert</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removePsychologicalTesting( index )" class="remove" title="Remove">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Calificari / Certificari</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Limbi straine</label> <a (click)="addLanguage()" class="form-control add">+</a>
                                                <ng-template
                                                        [ngForOf]="form.foreignLanguage" let-foreignLanguage let-index="index" ngFor ngModelGroup="foreignLanguage"
                                                        [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="foreignLanguage{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Limba</label>
                                                            <ng-select2
                                                                    [(ngModel)]=foreignLanguage.language
                                                                    [data]="foreignLanguages"
                                                                    [options]="singleOptions"
                                                                    name="language"
                                                            >
                                                            </ng-select2>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Nivel </label>
                                                            <select [(ngModel)]=foreignLanguage.level
                                                                    class="form-control" name="level">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Incepator">Incepator</option>
                                                                <option value="Mediu">Mediu</option>
                                                                <option value="Avansat">Avansat</option>
                                                                <option value="Nativ">Nativ</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeLanguage( index )" class="remove" title="Remove skill">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Certificari personale</label>
                                                <ng-select2
                                                        [(ngModel)]=project.professionalCertifications
                                                        [data]="foreignLanguages"
                                                        [options]="multiSelectOp"
                                                        name="professionalCertifications"
                                                >
                                                </ng-select2>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Permis de conducere</label>
                                                <ng-select2
                                                        [(ngModel)]=project.driverLicense
                                                        [data]="driverLicense"
                                                        [options]="multiSelectOp"
                                                        name="driverLicense"
                                                >
                                                </ng-select2>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row mb-10">
                                        <div class="col-lg-12"><h3>Experienta</h3></div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel total experienta in munca</label>
                                                <select [(ngModel)]=project.totalLevelWorkExperience
                                                        class="form-control"
                                                        name="totalLevelWorkExperience"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="incepator">Incepator</option>
                                                    <option value="mediu">Mediu</option>
                                                    <option value="avansat">Avansat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel experienta in munca in domeniul specificat</label>
                                                <select [(ngModel)]=project.levelWorkExperienceInSimilarActivitySector
                                                        class="form-control"
                                                        name="levelWorkExperienceInSimilarActivitySector"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="incepator">Incepator</option>
                                                    <option value="mediu">Mediu</option>
                                                    <option value="avansat">Avansat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel experienta in munca in subdomeniul specificat</label>
                                                <select [(ngModel)]=project.levelWorkExperienceInSimilarActivitySubSector
                                                        class="form-control"
                                                        name="levelWorkExperienceInSimilarActivitySubSector"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="incepator">Incepator</option>
                                                    <option value="mediu">Mediu</option>
                                                    <option value="avansat">Avansat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel experienta in munca in departamentul specificat</label>
                                                <select [(ngModel)]=project.levelWorkExperienceInSimilarDepartment
                                                        class="form-control"
                                                        name="levelWorkExperienceInSimilarDepartment"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="incepator">Incepator</option>
                                                    <option value="mediu">Mediu</option>
                                                    <option value="avansat">Avansat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Nivel experienta in munca pe o pozitie similara</label>
                                                <select [(ngModel)]=project.levelWorkExperienceInSimilarPosition
                                                        class="form-control"
                                                        name="levelWorkExperienceInSimilarPosition"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="incepator">Incepator</option>
                                                    <option value="mediu">Mediu</option>
                                                    <option value="avansat">Avansat</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Software specific activitatii desfasurate</label>
                                                <ng-select2
                                                        [(ngModel)]=project.specificSoftwareForActivityPerformed
                                                        [data]="driverLicense"
                                                        [options]="multiSelectOp"
                                                        name="specificSoftwareForActivityPerformed"
                                                >
                                                </ng-select2>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-lg-12"><h3>Conditii de lucru specifice</h3></div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Program de lucru</label>
                                                <select [(ngModel)]=project.workProgram
                                                        class="form-control"
                                                        name="workProgram"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="fixed">Fix</option>
                                                    <option value="flexible">Flexibil</option>
                                                    <option value="exchanges">Schimburi</option>
                                                    <option value="weekend_work">Lucru in weekend</option>
                                                    <option value="other">Altul</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Spatiu de lucru</label>
                                                <select [(ngModel)]=project.workSpace
                                                        class="form-control"
                                                        name="workSpace"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="interior">Interior</option>
                                                    <option value="exterior">Exterior</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Disponibilitate efort fizic</label>
                                                <select [(ngModel)]=project.physicalEffortAvailability
                                                        class="form-control"
                                                        name="physicalEffortAvailability"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="normal">Normal</option>
                                                    <option value="additional">Suplimentar</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Detalii efort fizic</label>
                                                <textarea [(ngModel)]=project.physicalEffortDetail
                                                          class="form-control"
                                                          name="physicalEffortDetail"
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <label>Interval varsta ideala</label>
                                                <select [(ngModel)]=project.idealAge
                                                        class="form-control"
                                                        name="idealAge"
                                                >
                                                    <option value="">-- Alege o optiune --</option>
                                                    <option value="18-29">18-29</option>
                                                    <option value="30-39">30-39</option>
                                                    <option value="40-49">40-49</option>
                                                    <option value="50-59">50-59</option>
                                                    <option value="60+">60+</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--end: Form Wizard Step 3-->

                                <!--begin: Form Wizard Step 4-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <div class="col-lg-12"><h3>Etape de recrutare</h3></div>
                                    <mat-vertical-stepper #stepper>
                                        <mat-step
                                                *ngFor="let recStep of project.recruitmentStage; index as i;"
                                                  id="stepgroup" label="{{recStep.name}}" ngModelGroup="recruitmentStage">
                                            <div class="row" id="step{{i}}" ngModelGroup="{{i}}">
                                                <input
                                                        [ngModel]=recStep.name
                                                        class="form-control"
                                                        id="stepname{{i}}"
                                                        name="name"
                                                        type="hidden"
                                                />
                                                <input
                                                        [ngModel]=recStep.position
                                                        class="form-control"
                                                        id="stepPos{{i}}"
                                                        name="position"
                                                        type="hidden"
                                                />
                                                <div class="col-md-6 form-group">
                                                    <label>Data de start</label>
                                                    <input
                                                            class="form-control"
                                                            id="startDate{{i}}"
                                                            name="startDate"
                                                            [ngModel]=recStep.startDate
                                                            type="date"
                                                    />
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label>Deadline</label>
                                                    <input
                                                            class="form-control"
                                                            id="deadLine{{i}}"
                                                            name="deadLine"
                                                            [ngModel]=recStep.deadLine
                                                            type="date"
                                                    />
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label>Durata</label>
                                                    <div class="input-group mb-2">
                                                        <input
                                                                class="form-control"
                                                                id="duration{{i}}"
                                                                name="duration"
                                                                [ngModel]=recStep.duration
                                                                type="number"
                                                        />
                                                        <div class="input-group-append">
                                                            <div class="input-group-text">zile</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 form-group" *ngIf="recruitersDataLoaded">
                                                    <label>Responsabil 1</label>
                                                    <ng-select2
                                                            [data]="recruitersNameArray"
                                                            [options]="singleOptions"
                                                            id="firstResponsibleId{{i}}"
                                                            name="firstResponsibleId"
                                                            [ngModel]=recStep.firstResponsibleId
                                                    >
                                                    </ng-select2>
                                                    <input ngModel
                                                            type="hidden"
                                                           name="firstResponsibleName"
                                                           id="firstResponsibleName{{i}}" />
                                                </div>
                                                <div class="col-md-6 form-group" *ngIf="recruitersDataLoaded">
                                                    <label>Responsabil 2</label>
                                                    <ng-select2
                                                            [data]="recruitersNameArray"
                                                            [options]="clientsOptions"
                                                            id="secondResponsibleId{{i}}"
                                                            name="secondResponsibleId"
                                                            [ngModel]=recStep.secondResponsibleId
                                                    >
                                                    </ng-select2>
                                                    <input ngModel
                                                            type="hidden"
                                                           name="secondResponsibleName"
                                                           id="secondResponsibleName{{i}}" />
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label>Resurse necesare</label>
                                                    <textarea class="form-control" id="necessaryResource{{i}}"
                                                              name="necessaryResource"  [ngModel]=recStep.necessaryResource
                                                    ></textarea>
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label>Observatii</label>
                                                    <textarea class="form-control" id="observation{{i}}"
                                                              name="observation" [ngModel]=recStep.observation></textarea>
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label>Status</label>
                                                    <select class="form-control" id="status{{i}}"
                                                            name="status" [ngModel]=recStep.status>
                                                        <option value="Nerealizat">Nerealizat</option>
                                                        <option value="Partial">Partial</option>
                                                        <option value="Realizat">Realizat</option>
                                                    </select>
                                                </div>

                                            </div>

                                        </mat-step>
                                    </mat-vertical-stepper>

                                </div>
                                <!--end: Form Wizard Step 4-->

                                <!--begin: Form Wizard Step 5-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Strategia proiectului</h3>
                                            <textarea [ngModel]=project.projectStrategy
                                                      class="form-control"
                                                      name="projectStrategy">
                                        </textarea>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Atragere candidati</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Canale interne</label> <a (click)="addInternChannel()" class="form-control add">+</a>
                                                <ng-template [ngForOf]="form.internChannel" let-channel let-index="index" ngFor
                                                             ngModelGroup="internChannel"  [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="channel{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume canal</label>
                                                            <input [ngModel]=channel.name
                                                                   class="form-control"
                                                                   name="name" type="text" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost canal estimat</label>
                                                            <input [ngModel]=channel.estimatedCost
                                                                    class="form-control"
                                                                   name="estimatedCost" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost canal final</label>
                                                            <input [ngModel]=channel.finalCost
                                                                   class="form-control"
                                                                   name="finalCost" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata canal</label>
                                                            <div class="input-group mb-2">
                                                                <input [ngModel]=channel.time
                                                                       class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeInternChannel( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Canale externe</label> <a (click)="addExternChannel()" class="form-control add">+</a>
                                                <ng-template
                                                        [ngForOf]="form.externChannel" let-channel let-index="index"
                                                        ngFor ngModelGroup="externChannel" [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="channel{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume canal</label>
                                                            <input [(ngModel)]=channel.name
                                                                   class="form-control"
                                                                   name="name" type="text" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost canal estimat</label>
                                                            <input [(ngModel)]=channel.estimatedCost
                                                                    class="form-control"
                                                                   name="estimatedCost" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost canal final</label>
                                                            <input [(ngModel)]=channel.finalCost
                                                                   class="form-control"
                                                                   name="finalCost" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata canal</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=channel.time
                                                                       class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeExternChannel( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Testarea si evaluarea candidatilor</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Teste tehnice (interne)</label> <a (click)="addInternalTechnicalTest()" class="form-control add">+</a>
                                                <ng-template
                                                             [ngForOf]="form.internalTechnicalTest"
                                                             let-index="index" let-test ngFor ngModelGroup="internalTechnicalTest" [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume test</label>
                                                            <select [ngModel]=test.name
                                                                    class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>

                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test estimat</label>
                                                            <div class="input-group mb-2">
                                                                <input [ngModel]=test.estimatedCost
                                                                       class="form-control mb-0" name="estimatedCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test final</label>
                                                            <div class="input-group mb-2">
                                                                <input [ngModel]=test.finalCost
                                                                       class="form-control mb-0" name="finalCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata test</label>
                                                            <div class="input-group mb-2">
                                                                <input [ngModel]=test.time
                                                                       class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeInternalTechnicalTest( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Teste tehnice (externe)</label> <a (click)="addExternalTechnicalTest()" class="form-control add">+</a>
                                                <ng-template
                                                             [ngForOf]="form.externalTechnicalTest" let-index="index" let-test
                                                             ngFor ngModelGroup="externalTechnicalTest" [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume test</label>
                                                            <select [(ngModel)]=test.name class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test estimat</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.estimatedCost class="form-control mb-0" name="estimatedCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test final</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.finalCost class="form-control mb-0" name="finalCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata test</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.time class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeExternalTechnicalTest( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Teste psihologice ABJ (interne)</label> <a (click)="addInternalPhysiologicalTest()" class="form-control add">+</a>
                                                <ng-template
                                                             [ngForOf]="form.internalPhysiologicalTest" let-index="index" let-test ngFor ngModelGroup="internalPhysiologicalTest"
                                                             [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume test</label>
                                                            <select [(ngModel)]=test.name
                                                                    class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test estimat</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.estimatedCost
                                                                       class="form-control mb-0" name="estimatedCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test final</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.finalCost
                                                                       class="form-control mb-0" name="finalCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata test</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.time
                                                                       class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeInternalPhysiologicalTest( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Teste psihologice ABJ (externe)</label> <a (click)="addExternalPhysiologicalTest()" class="form-control add">+</a>
                                                <ng-template
                                                             [ngForOf]="form.externalPhysiologicalTest" let-index="index" let-test ngFor ngModelGroup="externalPhysiologicalTest"
                                                             [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume test</label>
                                                            <select [(ngModel)]=test.name
                                                                    class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test estimat</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.estimatedCost
                                                                       class="form-control mb-0" name="estimatedCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test final</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.finalCost
                                                                       class="form-control mb-0" name="finalCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata test</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.time
                                                                       class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeExternalPhysiologicalTest( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Alte teste</label> <a (click)="addOtherTest()" class="form-control add">+</a>
                                                <ng-template
                                                             [ngForOf]="form.otherTest" let-index="index" let-test ngFor ngModelGroup="otherTest"
                                                             [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume test</label>
                                                            <select [(ngModel)]=test.name class="form-control" name="name">
                                                                <option value="">--Alege o optiune--</option>
                                                                <option value="Baza">Op1</option>
                                                                <option value="Mediu">Op2</option>
                                                                <option value="Avansat">Op3</option>
                                                                <option value="Expert">Op4</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test estimat</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.estimatedCost class="form-control mb-0" name="estimatedCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Cost test final</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.finalCost class="form-control mb-0" name="finalCost" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">euro</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Durata test</label>
                                                            <div class="input-group mb-2">
                                                                <input [(ngModel)]=test.time class="form-control mb-0"
                                                                       name="time" type="number">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">zile</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeOtherTest( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Recrutori</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div class="form-group">
                                                <label class="repeater-group">Adaugare recrutor</label> <a (click)="addRecruiter()" class="form-control add">+</a>
                                                <ng-template [ngForOf]="form.recruiters" let-index="index" let-recruiter ngFor ngModelGroup="recruiters"
                                                             [ngForTrackBy]="trackByFunction">
                                                    <hr>
                                                    <div class="row" ngModelGroup="recruiter{{index}}">
                                                        <div class="col-md-5">
                                                            <label>Nume recrutor</label>
                                                            <ng-select2
                                                                    [data]="recruitersNameArray"
                                                                    [options]="singleOptions"
                                                                    id="recruiterId{{index}}"
                                                                    name="recruiterId"
                                                                    [(ngModel)]=recruiter.recruiterId
                                                            >
                                                            </ng-select2>
                                                            <input ngModel
                                                                   name="recruiterName"
                                                                   id="recruiterName{{index}}"
                                                                   type="hidden" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Fee fix</label>
                                                            <input [(ngModel)]=recruiter.feeFixed
                                                                   class="form-control"
                                                                   name="feeFixed" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Fee vaiabil estimat</label>
                                                            <input [(ngModel)]=recruiter.feeEstimatedVariable
                                                                   class="form-control"
                                                                   name="feeEstimatedVariable" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Fee variabil realizat</label>
                                                            <input [(ngModel)]=recruiter.feeEstimatedPerformed
                                                                   class="form-control"
                                                                   name="feeEstimatedPerformed" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Bonus fix</label>
                                                            <input [(ngModel)]=recruiter.bonusFixed
                                                                   class="form-control"
                                                                   name="bonusFixed" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Bonus variabil estimat</label>
                                                            <input [(ngModel)]=recruiter.bonusEstimatedVariable
                                                                   class="form-control"
                                                                   name="bonusEstimatedVariable" type="number" />
                                                        </div>
                                                        <div class="col-md-5">
                                                            <label>Bonus variabil realizat</label>
                                                            <input [(ngModel)]=recruiter.bonusEstimatedPerformed
                                                                   class="form-control"
                                                                   name="bonusEstimatedPerformed" type="number" />
                                                        </div>
                                                        <div class="col-md-2">
                                                            <a (click)="removeRecruiter( index )" class="remove" title="Remove Value">
                                                                X
                                                            </a>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <h3>Costuri operationale</h3>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Deplasari estimat</label>
                                                        <input [(ngModel)]=project.estimatedTravel
                                                               class="form-control"
                                                               name="estimatedTravel" type="number" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Deplasari realizat</label>
                                                        <input [(ngModel)]=project.performedTravel
                                                               class="form-control"
                                                               name="performedTravel" type="number" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Comunicatii estimat</label>
                                                        <input [(ngModel)]=project.estimatedCommunication
                                                               class="form-control"
                                                               name="estimatedCommunication" type="number" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Comunicatii realizat</label>
                                                        <input [(ngModel)]=project.performedCommunication
                                                               class="form-control"
                                                               name="performedCommunication" type="number" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Altele estimat</label>
                                                        <input [(ngModel)]=project.estimatedOther
                                                               class="form-control"
                                                               name="estimatedOther" type="number" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Altele realizat</label>
                                                        <input [(ngModel)]=project.performedOther
                                                               class="form-control"
                                                               name="performedOther" type="number" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <h3>TOTAL</h3>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Total buget estimat</label>
                                                        <input ngModel='{{ getTotalEst() }}'
                                                               class="form-control"
                                                               name="totalEstimatedBudget" type="number" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Total buget realizat</label>
                                                        <input ngModel='{{ getTotalReal() }}'
                                                               class="form-control"
                                                               name="totalPerformedBudget" type="number"/>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Diferenta</label>
                                                        <input ngModel='{{ getDifference() }}'
                                                               class="form-control"
                                                               name="budgetDiff" type="number" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row justify-content-end pt-5">
                                        <button type="submit"
                                                class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                                        >
                                            Actualizeaza proiect
                                        </button>
                                    </div>

                                </div>
                                <!--end: Form Wizard Step 5-->

                                <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>


                                <!--begin: Form Actions -->
                                <div class="d-flex justify-content-between border-top pt-10">
                                    <div class="mr-2">
                                        <div
                                                class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-prev"
                                        >
                                            Inapoi
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                                class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-next"
                                        >
                                            Urmatorul pas
                                        </div>
                                    </div>
                                </div>
                                <!--end: Form Actions -->
                            </form>
                            <!--end: Form Wizard Form-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--end: Wizard -->
    </div>
</div>
